export default function getLocationName(locations: Array<any>, id: number) {
    return locations.find((x) => Number(x.id) === Number(id)).location;
}
